module.exports = __webpack_public_path__ + "static/img/eq2.80e1f8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/eq2.png
// module id = npCt
// module chunks = 0